/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

export const mutationEndpoints = {
  bookTrialSession: '/connect/v1/trialsession/book',
  previewContract: '/connect/v1/preview',
  createContract: '/connect/v1/rate-bundle',
};

export const queryEndpoints = {
  studios: () => '/connect/v2/studio',
  trialSessionSlots: () => '/connect/v1/trialsession',
  rateBundle: () => '/connect/v1/rate-bundle',
  validateIban: () => '/connect/v1/bankaccount',
  validateVoucher: ({ voucher }) => `/connect/v1/contractvoucher/${voucher}/validate`,
  utilization: ({ studioId }) => `/connect/v1/studio/${studioId}/utilization`,
};
